import { HttpClient } from 'core/common/services';
import { AskNebulaAccount, AuthData, NebulaAccount, NebulaAccountCreation } from '../entities';
import {
  AskNebulaAccountDtoMapper,
  AuthDtoMapper,
  NebulaAccountCreationDtoMapper,
} from '../mappers';
import { AskNebulaAccountDto, AuthDataDto, NebulaAccountDto } from './dto';

export class AuthService {
  constructor(private readonly httpClient: HttpClient) {}

  async authenticateByNebulaId(id: string, email: string, orderId?: string): Promise<AuthData> {
    const { data } = await this.httpClient.get<AuthDataDto>('/auth-funnel/generate-access-token', {
      params: { nebula_id: id, email, order_id: orderId },
    });

    const dtoMapper = new AuthDtoMapper();

    const mappedData = dtoMapper.toEntity(data);

    return mappedData;
  }

  async createNebulaAccount(payload: NebulaAccountCreation): Promise<NebulaAccount> {
    const { data } = await this.httpClient.post<NebulaAccountDto>('/nebula-auth/signup/funnel', {
      data: payload,
    });

    const dtoMapper = new NebulaAccountCreationDtoMapper();

    return dtoMapper.toEntity(data);
  }

  async setAskNebulaAccountPassword(password: string): Promise<AskNebulaAccount> {
    const { data } = await this.httpClient.put<AskNebulaAccountDto>(
      '/account-auth/account/password',
      {
        data: { password },
      },
    );

    const dtoMapper = new AskNebulaAccountDtoMapper();

    return dtoMapper.toEntity(data);
  }
}
